import { YearMonthPickerMobile } from '@/domain/termine/components/YearMonthPicker/mobile/YearMonthPickerMobile';
import { List } from '@/domain/termine/features/Calendar/List';
import { LoadingPageMobile } from '@/components/Loading/LoadingPageMobile';
import { YearMonthParams } from '@/domain/termine/type';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';

export function TermineMobileContent() {
  const { year, month } = useParams();
  const currentMonthAndYear: YearMonthParams = { year, month };
  return (
    <>
      <div className="sticky top-0 z-10 bg-white">
        <YearMonthPickerMobile currentMonthAndYear={currentMonthAndYear} />
      </div>
      <Suspense fallback={<LoadingPageMobile />}>
        <div className="p-4">
          <List />
        </div>
      </Suspense>
    </>
  );
}
